import {
    BulkCustomerCicReportingReducer,
    BulkCustomerCicReportingReducerStateWithListObject,
    BulkCustomerCicReportingReducerStateWithoutListObject,
    bulkCustomerCicReportingType
} from "./types";

const OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE = {
    data: {},
    loading: false,
    error: null
};

const OBJECT_WITH_LIST_RESPONSE_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
};

const UploadBulkCustomerCicReportingReducer = (
    state: BulkCustomerCicReportingReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING: {
            return {
                loading: true
            };
        }
        case bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        }
        case bulkCustomerCicReportingType.RESET_UPLOAD_BULK_CUSTOMER_CIC_REPORTING: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }

        default:
            return { ...state };
    }
};

const ListBulkCustomerCicReportingReducer = (
    state: BulkCustomerCicReportingReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: true
            };
        }
        case bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            };
        }
        case bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        }

        case bulkCustomerCicReportingType.RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING:
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            };
        default:
            return { ...state };
    }
};

const BulkCustomerCicReportingDetailReducer = (
    state: BulkCustomerCicReportingReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL: {
            return {
                loading: true
            };
        }
        case bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        }
        case bulkCustomerCicReportingType.RESET_FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }

        default:
            return { ...state };
    }
};

const BulkCustomerCicReportingVersionRecordReducer = (
    state: BulkCustomerCicReportingReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION: {
            return {
                ...state,
                loading: true
            };
        }
        case bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            };
        }
        case bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        }

        case bulkCustomerCicReportingType.RESET_BULK_CUSTOMER_CIC_REPORTING_VERSION:
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            };
        default:
            return { ...state };
    }
};

const BulkCustomerCicReportingPublishReducer = (
    state: BulkCustomerCicReportingReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH: {
            return {
                loading: true
            };
        }
        case bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH_ERROR: {
            return {
                ...state,
                loading: false,
                data: {},
                error: action.payload.error
            };
        }
        case bulkCustomerCicReportingType.RESET_BULK_CUSTOMER_CIC_REPORTING_PUBLISH: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }

        default:
            return { ...state };
    }
};

const DownloadBulkCustomerCicReportingReducer = (
    state: BulkCustomerCicReportingReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD: {
            return {
                loading: true
            };
        }
        case bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        }
        case bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };
        }
        case bulkCustomerCicReportingType.RESET_BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD:
            return {
                data: {},
                loading: false,
                error: null
            };
        default:
            return { ...state };
    }
};

const ListBulkFileSpecificCustomerCicReportingReducer = (
    state: BulkCustomerCicReportingReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: true
            };
        }
        case bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            };
        }
        case bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        }

        case bulkCustomerCicReportingType.RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING:
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            };
        default:
            return { ...state };
    }
};

const ApproveBulkCustomerCicReportingFileReducer = (
    state: BulkCustomerCicReportingReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE: {
            return {
                loading: true
            };
        }
        case bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                data: {},
                error: action.payload.error
            };
        }
        case bulkCustomerCicReportingType.RESET_APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }

        default:
            return { ...state };
    }
};

const RejectBulkCustomerCicReportingFileReducer = (
    state: BulkCustomerCicReportingReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE: {
            return {
                loading: true
            };
        }
        case bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        }
        case bulkCustomerCicReportingType.RESET_REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }

        default:
            return { ...state };
    }
};


const DeleteBulkCustomerCicReportingFileReducer = (
    state: BulkCustomerCicReportingReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE,
    action: BulkCustomerCicReportingReducer
) => {
    switch (action.type) {
        case bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE: {
            return {
                loading: true
            };
        }
        case bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkCustomerCicReportingType.RESET_DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

export {
    UploadBulkCustomerCicReportingReducer,
    ListBulkCustomerCicReportingReducer,
    BulkCustomerCicReportingDetailReducer,
    BulkCustomerCicReportingVersionRecordReducer,
    BulkCustomerCicReportingPublishReducer,
    DownloadBulkCustomerCicReportingReducer,
    ListBulkFileSpecificCustomerCicReportingReducer,
    ApproveBulkCustomerCicReportingFileReducer,
    RejectBulkCustomerCicReportingFileReducer,
    DeleteBulkCustomerCicReportingFileReducer
};
